const PAGES = {
  website: "https://checkdpe.fr",
  home: "/",
  edit: "/edit/:id",
  list: "/list",
  settings: "/settings",
  dashboard: "/dashboard/:id",
  insight: "/insight/:id",
  login: "/login",
  signup: "/signup",
  confirmationSignup: "/confirmation-signup",
  forgotPassword: "/forgot-password",
  account: "/account",

  acheter: "/acheter",
  vendre: "/vendre",
  renover: "/renover",
  reCalculate: "/re-calcul",
  cstb: "/cstb",
  address: "/address/:address",
  controls: "/controls",
  upload: "/upload",

  //stripe
  stripe: "/stripe",
  paymentComplete: "/payment-complete",

  neighborsMap: "/neighbors-map/:id",

  // iframe routes
  iframeMondpe: "/iframe/mondpe/:id",
  iframeFiabilite: "/iframe/fiabilite/:id",
};

export const getDashboardURL = (id: string) => {
  return PAGES.dashboard.replace(":id", id);
};

export const getAddressURL = (address: string) => {
  return PAGES.address.replace(":address", encodeURIComponent(address));
};

export const getInsightURL = (id: string) => {
  return PAGES.insight.replace(":id", id);
};

export default PAGES;
